<template>
  <div id="main-content" class="add-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.class') }}</span>
            </el-col>
            <el-col :span="16">
              <el-select v-model="class_data.level" :placeholder="$t('common.please_select')">
                <el-option
                    v-for="classItem in baseClassList"
                    :key="classItem.level"
                    :label="classItem.name"
                    :value="classItem.level">
                </el-option>
              </el-select>
            </el-col>
            <el-col v-if="error_message.level" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.level" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
<!--          <el-col :span="12" style="display: inline">-->
<!--            <el-col :span="8">-->
<!--              <span class="required-star">* </span><span class="form-lable">{{ $t('class.sub_name') }}</span>-->
<!--            </el-col>-->
<!--            <el-col :span="16">-->
<!--              <el-input v-model="class_data.sub_name" />-->
<!--            </el-col>-->
<!--            <el-col v-if="error_message.sub_name" :offset="8" :span="16">-->
<!--              <span v-for="(value, key) in error_message.sub_name" :key="key" class="form-error"> {{ value }}</span>-->
<!--            </el-col>-->
<!--          </el-col>-->
        </el-row>


        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "AddClass",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/classroom?action=back`,
        title: 'class_list.add_class',
        class_data: {
          level: '',
          // sub_name: '',
          drop_time_list: [{
            date: "",
            time: ""
          }]
        },
        activeNames: ['1'],
        error_message: {
          level: [],
          // sub_name: [],
          grade: [],
          date_list: [{date: [], time: [], isError: false}]
        },
        baseClassList: [],
        pickerOptions: {
          disabledDate: (time) => {
            let date = this.$moment(time).format('YYYY-MM-DD')
            let currentDate = this.$moment().format('YYYY-MM-DD')

            return date < currentDate
          }
        },
        duplicatedDateList: []
      }
    },
    methods: {
      addDateRanger(e){
        e.forEach(item=>{
          this.class_data.drop_time_list.unshift(item)
          this.error_message.date_list.unshift({date: [], time: [], isError: false})
        })
      },
      addDate: function () {
        this.class_data.drop_time_list.push({date: "", time: ""})
        this.error_message.date_list.push({date: [], time: [], isError: false})
      },
      removeDate(index) {
        this.class_data.drop_time_list.splice(index, 1)
        this.error_message.date_list.splice(index, 1)
      },
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/classroom')
          };
          let payload = {
            successCallback,
            data: this.class_data
          }

          this.$store.dispatch('classroom/createClass', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.level = []
        if (this.class_data.level === "") {
          this.error_message.level.push('* ' + this.$t('common.class_is_required'))
          check = false
        }

        // this.error_message.sub_name = []
        // if (this.class_data.sub_name === "") {
        //   this.error_message.sub_name.push('* ' + this.$t('class.sub_name_is_required'))
        //   check = false
        // }

        return check
      },
      validateList(index, value) {
        var check = true
        this.error_message.date_list[index].date = []
        if (value.date === "") {
          check = false
          this.error_message.date_list[index].date.push('* ' + this.$t('common.date_is_required'))
        }

        this.error_message.date_list[index].time = []
        if (value.time === "") {
          check = false
          this.error_message.date_list[index].time.push('* ' + this.$t('common.time_is_required'))
        }

        this.error_message.date_list[index].isError = !check
        return check
      },
      onChange: function () {
        this.duplicatedDateList = []
      }
    },
    mounted: function () {
      this.$store.dispatch('classroom/retrieveBaseClassList', {
        successCallback: (response) => {
          this.baseClassList = [].concat(response.data.data.class_list)
        }
      })
    },
    computed: {}
  }
</script>

<style lang="scss">
  .edit-class .el-collapse-item__header,
  .add-class .el-collapse-item__header {
    font-size: 22px;
  }

  #drop-time select {
    width: 12%;
    float: left;
    margin-right: 25px;
    margin-left: 2px;
  }
</style>
